import axios from "../../publicApi";

export const loginWithSessionIdFailedAlert = async (sessionId: string) => {
  const body = { sessionId };
  return axios.post("/payments/login-with-session-id-failed-alert", body);
};
